<script lang="ts">
    import type { EntityVariant } from "../../../../Phaser/Game/MapEditor/Entities/EntityVariant";
    import { triggerClickOnEnterOrSpace } from "../../../../Utils/svelte-a11y";
    import EntityImage from "./EntityImage.svelte";

    interface Props {
        entityVariant: EntityVariant;
        isActive: boolean;
        onselectentity?: (entityVariant: EntityVariant) => void;
    }

    let { entityVariant, isActive, onselectentity }: Props = $props();
</script>

<div
    data-testid="entity-item"
    role="button"
    tabindex="0"
    aria-pressed={isActive}
    aria-label={entityVariant.defaultPrefab.name}
    class={`flex items-center justify-center box-border py-0.5 cursor-pointer border-solid border-transparent h-full w-full bg-mlight-darker rounded-2xl hover:bg-white/20 hover:border-white hover:animate-pulse ${
        isActive ? "border-solid border-yellow-400 rounded-2xl" : ""
    }`}
    onclick={() => onselectentity?.(entityVariant)}
    onkeydown={triggerClickOnEnterOrSpace}
>
    <EntityImage
        classNames="cursor-pointer w-14 h-14 object-contain rounded-md"
        imageSource={entityVariant.defaultPrefab.imagePath}
        imageAlt={entityVariant.defaultPrefab.name}
    />
</div>
